
<template>
  <naj-modal
    ref="requestsFeesEstimationModal"
    :title="local.judicialFees.requestsFeesEstimation.title"
    button-size="small"
    :button-outlined="false"
    :width="700"
    :persistent="true"
    :close-button="true"
    show-footer-close-button
    :content-loaded="(allProduct||[]).length>0"
    @onClose="onModalClose( )"
  >
      <naj-alert type="information">
          <template slot="content">
              {{ local.judicialFees.requestsFeesEstimation.judicialFessExceptionInfo }}
          </template>
      </naj-alert>
    <v-form ref="requestsFeesEstimationFromRef">
      <v-row>
        <v-col
          cols="12"
          class="pa-0"
        >
          <div class="request-header">
            <div
              v-for="(header, headerIndex) in headers"
              :key="'header-items-'+headerIndex"
              class="product-item pa-2"
            >
              <div>
                {{ header.text }}
              </div>
            </div>
          </div>

          <div
            v-for="(item, itemIndex) in items"
            :key="'item-Index-'+itemIndex"
            class="product-item-row"
          >
            <div
              v-for="(header,index) in headers"
              :key="header.value+'-'+index"
              class="product-item pa-2"
            >
              <div class="product-item-value">
                {{ header.formatter?header.formatter(item[header.value]):item[header.value] }}
              </div>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          lg="12"
        >
          <naj-input
            :type-id="formFieldType.checkbox"
            :value.sync="requestsFeesEstimationPledge"
            :label="local.judicialFees.requestsFeesEstimation.confirmationMessage"
            class="inline-label primary-label-color pledged"
            validates="required"
            @change="pledgedChange"
          ></naj-input>
          <div
            v-if="requestsFeesEstimationPledgeChanged && !requestsFeesEstimationPledge"
            class="error--text"
          >
            {{ local.judicialFees.requestsFeesEstimation.pledgeErrorText }}
          </div>
        </v-col>
      </v-row>
    </v-form>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button
        :loading="loading"
        @click="submit(closeNajModal)"
      >
        {{ local.judicialFees.requestsFeesEstimation.submit }}
      </naj-button>
    </template>
  </naj-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('LawsuitModule');

export default {
  name: 'RequestsFeesEstimationModal',
  components: {},
  props: {
    estimateRequests: {
      default: null,
      type: Array,
      required: true,
    },
    modalVisibility: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      headers: [
        {
          value: 'name',
          text: this.local.judicialFees.requestsFeesEstimation.requestName,
        },
        {
          value: 'amount',
          text: this.local.judicialFees.requestsFeesEstimation.amountInSAR,
          formatter: (val) => {
            return val ? `${val} ${this.local.judicialFees.sar}` : this.local.judicialFees.requestsFeesEstimation.zeroAmountFees;
          },
        },
      ],
      items: [],
      requestsFeesEstimationPledge: false,
      requestsFeesEstimationPledgeChanged: false,
      loading: false,
    };
  },
  computed: {
    allProduct() {
      return this.items;
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions([
      'getRequestsFeesEstimation',
    ]),
    submit() {
      this.requestsFeesEstimationPledgeChanged = true;
      if (this.requestsFeesEstimationPledge) {
        this.$emit('successSubmitPledge');
        this.closeModal();
      }
    },
    showModal() {
      this.$refs.requestsFeesEstimationModal.show();
      this.loadRequestsFeesEstimationData();
    },
    closeModal() {
      this.$refs.requestsFeesEstimationModal.close();
    },
    onModalClose() {
      this.$set(this, 'items', null);
      this.$set(this, 'requestsFeesEstimationPledge', false);
      this.$set(this, 'requestsFeesEstimationPledgeChanged', false);
    },
    pledgedChange() {
      this.requestsFeesEstimationPledgeChanged = false;
    },

    loadRequestsFeesEstimationData() {
      this.loading = true;
      this.getRequestsFeesEstimation(this.estimateRequests)
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          this.toaster.error(err.message);
          this.closeModal();
        }
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.request-header {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
  background: #009587;
  color: #fff;
}
.product-item-row {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
}

.product-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  padding: 0 10px 0 10px;
}

.product-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: #717171;
}

.pledged {
  ::v-deep .v-input__slot {
    align-items: flex-start;
  }
}
</style>
